import React, { useEffect } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import WorkWeChatOauth2 from './login/WorkWeChatOauth2'
import WorkWeChatQR from './login/tabsPage/WorkWechat'
import DoubleFactor from './double-factor'
import Logout from './logout'
import WechatLogin from './get-wechat-code'
import { isMobileBrowser } from 'utils/tools'
import './index.css'
import qs from 'querystring'

/** 使用移动端浏览器展示方式的url正则列表 */
const useMobileBrowserUrlRegList = [/\/app-sobot-h5\//]

const App = ({ history }) => {
  const search = window.sessionStorage.getItem('search')
  const { url } = qs.parse(search.substring(1))

  const renderRouter = () => {
    let redirectUrl = ''

    try {
      redirectUrl = decodeURIComponent(
        qs.parse(new URL(url).search.substring(1)).redirectUrl
      )
    } catch (e) {}

    const mobile = <Route path="/" component={require('./mobile').default} />,
      pc = <Route path="/" component={require('./login').default} />

    if (useMobileBrowserUrlRegList.some(reg => reg.test(redirectUrl))) {
      return mobile
    }

    if (isMobileBrowser()) {
      return mobile
    }

    return pc
  }

  useEffect(() => {
    const { origin, pathname } = window.location
    /**
     * 判断如果是app项目需要使用双因子登录
     */
    if (
      url &&
      url.includes('app-admin') &&
      !['/double-factor', '/oauth'].includes(pathname)
    ) {
      const reacturl = `${origin}/double-factor${search}`
      window.location.href = reacturl
    }
  }, [])

  return (
    <Router history={history}>
      <div className="box">
        <Switch>
          <Route path="/logout">
            <Logout />
          </Route>
          <Route path="/work-wechat-oauth2">
            <WorkWeChatOauth2 />
          </Route>
          <Route path="/work-wechat-qr">
            <WorkWeChatQR />
          </Route>
          <Route path="/double-factor">
            <DoubleFactor />
          </Route>
          <Route path="/oauth" component={require('./oauth').default} />
          <Route path="/wechat-login">
            <WechatLogin />
          </Route>
          {renderRouter()}
        </Switch>
      </div>
    </Router>
  )
}

export default App
